<template>
    <div class="progress">
        <div class="progress__steps">
            <span v-for="(step, index) in productFinderStore.pages" :key="index" class="progress__step" :class="{ 'is-complete' : productFinderStore.currentStep > index, 'is-active' : productFinderStore.currentStep == index }" v-if="step.routeName != 'Results'">
                <span class="progress__indicator"></span>

                <div class="progress__number-wrapper">
                    <span class="progress__number"><span class="progress__number-text">Step</span> {{ index + 1 }}</span>
                    <span class="progress__text">{{ step.pageName }}</span>
                </div>

                <span v-if="index != productFinderStore.pages.length - 1" class="horizontal-line"></span>
            </span>
        </div>
    </div>
</template>

<script setup>
import { useProductFinderStore } from '../../stores/product-finder';

const productFinderStore = useProductFinderStore();

const setStep = (step) => {
    if (productFinderStore.currentStep > step) {
        productFinderStore.setStep(step);
    }
};

</script>

<style lang="scss" scoped>

.progress__indicator {
    position: relative;
    display: block;
    margin: 0;
    height: 34px;
    width: 34px;
    background-image: url('/build/images/icon-step-incomplete.svg');
    background-size: 100% 100%;
    z-index: 10;

    @media (min-width: 768px) {
        height: 50px;
        width: 50px;
        background-size: 50px 50px;
    }
}

.is-complete .progress__indicator {
    background-image: url('/build/images/icon-step-complete.svg');
}

.is-active .progress__indicator {
    background-image: url('/build/images/icon-step-active.svg');
}

.progress__steps {
    display: flex;
    align-items: start;
    justify-content: center;
    justify-content: space-between;
    color: #fff;
    text-align: center;
    max-width: 1050px;
    margin: 0 auto;

    .progress__step {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 150px;

        a {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
        }

        .horizontal-line {
            height: 0px;
            border-top: 2px solid #ddd;
            width: 100%;
            position: absolute;
            width: 60px;
            right: 0;
            transform: translateX(50%);
            top: 23%;
            padding: 0 10px;

            @media (min-width: 768px) {
                width: 80px;
            }
        }

        .progress__number{
            color: #999;
            font-size: 11px;
            font-style: normal;
            font-weight: 450;
            line-height: 1;
            letter-spacing: 1.1px;
            text-transform: uppercase;
            margin-bottom: 0px;
            margin-top: 15px;

            @media (min-width: 768px) {
                margin-bottom: 9px;
            }
        }

        .progress__number-text{
            display: none;

            @media (min-width: 768px) {
                display: inline-block;
            }
        }

        .progress__text{
            display: none;
            color: #FFF;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 1.28;
            text-align: center;

            @media (min-width: 768px) {
               display: block;
            }
        }
    }
}

</style>